import { render, staticRenderFns } from "./helpComponent.vue?vue&type=template&id=f4fe6c06&scoped=true"
import script from "./helpComponent.vue?vue&type=script&lang=js"
export * from "./helpComponent.vue?vue&type=script&lang=js"
import style0 from "./helpComponent.vue?vue&type=style&index=0&id=f4fe6c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fe6c06",
  null
  
)

export default component.exports